export const USER_PERMISSION = {
  count:-1,
  data:{},
  message:""
}

export const ERROR_MESSAGE_API_RESPONSE = {
    message:""
  }